import React, { useState } from "react";
import { Box, Button, Stack, Dialog, DialogContent } from "@mui/material";

// import AlertDialog from "src/components/AlertDialog";
import useFetchData from "../utilities/useFetchData";
import PageContainer from "src/components/container/PageContainer";
import DashboardCard from "src/components/shared/DashboardCard";
import DataTable from "src/components/DataTable";

// import AddHostelStaff from "./components/AddHostelStaff";
import Loadable from "src/layouts/full/shared/loadable/Loadable";
import AddPlan from "../master/components/AddPlan";
import { useQueryClient } from "react-query";
import { exportToExcel } from "../utilities/excelUtils";
import PlanHistory from "../master/components/PlanHistory";
import AddUser from "./AddUser";

const columns = [
  { field: "id", headerName: "ID", width: 90 },
  {
    field: "staffName",
    headerName: "Name",
    flex: 1,
    minWidth: 150,
  },
  {
    field: "Phone",
    headerName: "Phone",
    flex: 1,
    minWidth: 150,
  },
  {
    field: "address1",
    headerName: "Address",
    flex: 1,
    minWidth: 150,
  },
  {
    field: "ItemName",
    headerName: "Active Plan",
    flex: 1,
    minWidth: 150,
  },

  //   {
  //     field: "hostel",
  //     headerName: "Hostel",
  //     flex: 1,
  //     minWidth: 150,
  //   },
];

function Users() {
  const { data, isLoading, error } = useFetchData(
    "staffData",
    "/api/getUsersForAdmin"
  );
  //   const { showSnackbar } = useSnackBar();
  const queryClient = useQueryClient();
  // const [loading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const [openUser, setOpenUser] = useState(false);

  const [user, setUser] = useState(null);

  const [editData, setEditData] = useState({});
  // const [alert, setAlert] = useState({
  //   open: false,
  //   onConfirm: null,
  //   onCancel: null,
  //   title: "",
  //   message: "",
  //   buttonType: "",
  //   buttonText: "",
  // });

  const handleClickOpen = (data) => {
    if (data.uid) {
      setEditData(data);
    } else {
      setEditData({});
    }

    setOpen(true);
  };
  const handleClickOpen2 = (data) => {
    setEditData(data);
    setOpen2(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  const handleOpenUser = () => {
    setOpenUser(true);
  };

  const handleCloseUser = () => {
    setOpenUser(false);
    setUser(null);
  };
  if (isLoading) return <Loadable />;
  if (error)
    return (
      <>
        <Loadable />
        <p>Error: {error.message}</p>
      </>
    );

  const handleRefetch = () => {
    queryClient.invalidateQueries("staffData");
  };

  //   const handleDelete = async (params) => {
  //     setLoading(true);
  //     try {
  //       const response = await deleteData(
  //         `/api/deleteHostelStaff?uid=${params.uid}`
  //       );
  //       if (response.success) {
  //         showSnackbar("error", response.message);
  //         handleRefetch();
  //         cancelPrint();
  //       } else {
  //         showSnackbar("warning", response.message);
  //       }
  //     } catch (error) {
  //       if (error.response.status === 401 || error.response.status === 403) {
  //         window.location.href = redirectUrl;
  //       }
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   const cancelPrint = () => {
  //     setAlert({
  //       open: false,
  //     });
  //   };

  const renderButtons = (params) => (
    <Stack direction="row" gap={2}>
      <Button
        size="small"
        variant="contained"
        color="secondary"
        onClick={() => handleClickOpen(params)}
      >
        Assign Plan
      </Button>
      <Button
        size="small"
        variant="contained"
        color="warning"
        onClick={() => handleClickOpen2(params)}
      >
        History
      </Button>
      <Button
        size="small"
        variant="contained"
        color="info"
        onClick={() => handleSelectUser(params)}
      >
        Edit
      </Button>
      {/* <IconButton
        aria-label="delete"
        color="error"
       size="small"
        onClick={() =>
          openAlert({
            open: true,
            // onConfirm: () => handleDelete(params),
            onCancel: cancelPrint,
            title: "Delete",
            message: "Do you want to delete this Staff?",
            buttonType: "error",
            buttonText: "Delete",
            row: params,
          })
        }
      > */}
      {/* <DeleteIcon />
      </IconButton> */}
    </Stack>
  );

  const columnsWithButtons = [
    ...columns,
    {
      field: "actions",
      headerName: "Actions",
      renderCell: renderButtons,
      sortable: false,
      filterable: false,
      flex: 1,
      minWidth: 150,
    },
  ];

  const handleSelectUser = (data) => {
    console.log(data);
    setUser(data);
    setOpenUser(true);
  };
  return (
    <>
      {/* <Loader start={loading} /> */}
      {/* <AlertDialog
        open={alert.open}
        onConfirm={alert.onConfirm}
        onCancel={alert.onCancel}
        title={alert.title}
        message={alert.message}
        buttonType={alert.buttonType}
        buttonText={alert.buttonText}
      /> */}
      <Dialog
        open={open}
        onClose={handleClose}
        labelled="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <AddPlan
            onClose={handleClose}
            refetch={handleRefetch}
            editData={editData}
            plansMaster={data.staffData.plansMaster}
            plans={data.staffData.plans}
          />
        </DialogContent>
      </Dialog>
      <Dialog
        open={openUser}
        onClose={handleCloseUser}
        labelled="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <AddUser onCancel={handleCloseUser} selectedUser={user} />
        </DialogContent>
      </Dialog>
      <Dialog
        open={open2}
        onClose={handleClose2}
        labelled="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <PlanHistory
            onClose={handleClose2}
            plans={data.staffData.plans}
            data={editData}
          />
        </DialogContent>
      </Dialog>
      <PageContainer>
        <DashboardCard title="Users">
          <Stack direction="row" justifyContent="flex-end" gap={2}>
            <Button
              size="small"
              variant="contained"
              color="secondary"
              onClick={handleOpenUser}
            >
              Add user
            </Button>
            <Button
              size="small"
              variant="contained"
              color="secondary"
              onClick={() =>
                exportToExcel([...data.staffData.data], "UsersList.xlsx")
              }
            >
              Export To Excel
            </Button>
          </Stack>
          <Box>
            <DataTable
              columns={columnsWithButtons}
              rows={data.staffData.data}
            />
          </Box>
        </DashboardCard>
      </PageContainer>
    </>
  );
}

export default Users;
